module.exports = __webpack_public_path__ + "49aac2260586d57e388b3b0a014afb95.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/graviton_-_agudablackunicase-webfont.woff
// module id = 1310
// module chunks = 28